// AuthContext.js
import React, { useEffect, useState } from 'react';
import localStorageTemplates from 'common/local-storage-templates';
import { Mixpanel } from 'utils/Mixpanel';
import { MIXPANEL_EVENTS } from 'common/mixpanelEvents';
import queryString from 'query-string';

export const AuthContext = React.createContext();

export default ({ children }) => {
  const searchParams = queryString.parse(window.location.search);
  const isChatOnly = searchParams['chat_only'] && searchParams['chat_only'] === 'true';
  const isTeamsOnlyToken = localStorage.getItem(localStorageTemplates.teamsOnlyToken) || false;
  const {
    tenant: tenantId,
    group: teamId,
    channelId,
    userObjectId,
    userPrincipalName,
  } = searchParams;
  const isTeamsParamsPresent = tenantId && teamId && channelId && userObjectId && userPrincipalName;
  const prevAuth =
    (!isChatOnly && isTeamsOnlyToken) || (isTeamsOnlyToken && !isTeamsParamsPresent)
      ? ''
      : localStorage.getItem(localStorageTemplates.insentPublisherLoginToken) || '';
  const [authenticated, setAuthenticated] = useState(prevAuth);
  useEffect(() => {
    if (authenticated) {
      localStorage.setItem(localStorageTemplates.insentPublisherLoginToken, authenticated);
    }
  }, [authenticated]);

  const logOut = () => {
    Mixpanel.track(MIXPANEL_EVENTS.USER_LOGOUT);
    setAuthenticated('');
    localStorage.clear();
    Mixpanel.reset();
    try {
      window.insent.widget('hide');
    } catch (e) {
      // insent not initialized
    }
  };

  const defaultContext = {
    authenticated,
    setAuthenticated,
    logOut,
  };
  return <AuthContext.Provider value={defaultContext}>{children}</AuthContext.Provider>;
};
